// The credit is the unit of account. One LLM call costs a fraction of a credit,
// so amounts are stored as integers in a finer sub-unit: 1 credit =
// CREDIT_SUBUNIT stored units.
//
// Which unit applies where:
//   credits    an amount a human decides — a plan, an allowance, a figure typed
//              into a form.
//   sub-units  an amount derived from a computation — consumption, a rate card,
//              a recharge converted from euros. Every credit column stores
//              these, and so do `Balance` and `CreateLotRequest`.
//
// `creditsToStored` is the boundary between the two. Lives in core-shared so the
// API and the front share one definition.
export const CREDIT_SUBUNIT = 1000;
// A whole-credit amount → what core-api stores. Exact: what crosses here is an
// integer number of credits.
export function creditsToStored(credits) {
    return credits * CREDIT_SUBUNIT;
}
